import { getEnv, getModuleBaseUrl } from '@/utils/env';

const parsePublicAssetsPath = (path: string): string => (getEnv().DEV ? new URL(path, getModuleBaseUrl()).href : path);

export default parsePublicAssetsPath;
